module.exports = __webpack_public_path__ + "static/media/baisheng_1280X720.6f6463c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameVideo/baisheng_1280X720.mp4
// module id = bDQm
// module chunks = 0